export const error = (state) => state.error;
export const isLoading = (state) => state.isLoading;
export const items = (state) => state.items;
export const item = (state) => state.item;
export const infoMessages = (state) => state.infoMessages;
export const user = (state) => state.user;
export const userLoading = (state) => state.userLoading;
export const ownTrainer = (state) => state.ownTrainer;
export const freeSkillpoints = (state) => state.ownTrainer ? state.ownTrainer.experience.skillpoints : 0;
export const pvpMatches = (state) => state.pvpMatches;
export const pvpRankedList = (state) => state.pvpRankedList;
